import { lazy } from "react";

const InvoiceList = lazy(() => import("./InvoiceList"));
const InvoiceDetails = lazy(() => import("./InvoiceDetails"));
const InvoiceImportWizard = lazy(() => import("./import/InvoiceImportWizard"));

const invoiceRoutes = [
  { path: "/invoice/list", element: <InvoiceList /> },
  { path: "/invoice/import", element: <InvoiceImportWizard /> },
  { path: "/invoice/:id", element: <InvoiceDetails /> }
];

export default invoiceRoutes;
